import type { MonoIconType } from '@/components/ui/icon';

export type AppIcon = MonoIconType;

/** Centralized icon type names. Use with MonoIcon type="..." */
export const Icons = {
  AcademicCap: 'AcademicCap',
  Plug: 'Plug',
  Billing: 'Billing',
  Bolt: 'Bolt',
  Brain: 'Brain',
  Building2: 'Building2',
  ChartNoAxesColumn: 'ChartNoAxesColumn',
  ChartNoAxesColumnIncreasing: 'ChartNoAxesColumnIncreasing',
  ChevronDown: 'ChevronDown',
  ChevronLeft: 'ChevronLeft',
  CircleUserRound: 'CircleUserRound',
  CodeBracket: 'CodeBracket',
  Cog: 'Cog',
  FolderOpen: 'FolderOpen',
  GitDiff: 'GitDiff',
  Globe: 'Globe',
  Grid: 'Grid',
  History: 'History',
  Layers: 'Layers',
  Link: 'Link',
  Link2: 'Link',
  Lock: 'Lock',
  MoreHorizontal: 'MoreHorizontal',
  MoreVertical: 'MoreVertical',
  Plus: 'Plus',
  ScrollText: 'ScrollText',
  Settings: 'Cog',
  Tags: 'Tag',
  Tag: 'Tag',
  Ticket: 'Ticket',
  UserGroup: 'UserGroup',
  Users: 'UserGroup',
  UserPlus: 'UserPlus',
  Workspace: 'Workspace',
  X: 'X'
} as const satisfies Record<string, MonoIconType>;
